module.exports = __webpack_public_path__ + "static/media/svit.7282fda5.png";